/* global modForm Modalytics */
import { trackFormSubmissionFlow } from '../../helpers';
/**
 * In order to determine if all gtm tags have fired, we're adding classes to the body when they load in
 * When both classes exist, redirect logic will then be followed
 * @param {Object} mutations - passed by mutation observer
 */
export function subscribeToNonTYPMutations(mutations) {
	trackFormSubmissionFlow({ inSubscribeToNonTYPMutations: true });
	mutations.some((record) => {
		if (record.type === 'attributes' && ~record.target.className.indexOf('gtm-aio-complete')) {
			Modalytics.heap('track', ['Mutation Observer redirect']);
			// guarantee fallback setTimeout doesn't fire
			clearTimeout(window.timeOutId);

			if (!modForm.opts.autoRedirectToTyOrSorryPage) {
				return true;
			}

			if (window.Loader && modForm.opts.showRedirectOverlay) {
				window.Loader.showRedirectAnimation(); // eslint-disable-line no-undef
				Modalytics.heap('track', ['Loader Visible - Transferring to Modernize']);
				setTimeout(function() {
					setTimeout(function() {
						window.location.href = modForm.projexURL;
					}, 500);
					document.body.classList.add('submitted');
				}, 2500);
			} else {
				document.body.classList.add('submitted');
				setTimeout(function() {
					window.location.href = modForm.projexURL;
				}, 500);
			}

			return true;
		}
	});
}
